export const mutations = {
  /**
   * set object fields
   * @param {Object[]} fields
   */
  setFields(state, { fields, objectUUID }) {
    state.objectFieldsMap = { ...state.objectFieldsMap, [objectUUID]: fields };
  },

  /**
   * set Object Template details in map
   * @param {Object} template
   */
  setTemplate(state, template) {
    state.templateMap = { ...state.templateMap, [template.UUID]: template };
  },

  /**
   * set Object Template widgets in map
   * @param {Object} templateWidgets
   */
  setTemplateWidgets(state, { widgets, templateUUID }) {
    state.templateWidgetsMap = { ...state.templateWidgetsMap, [templateUUID]: widgets };
  },

  /**
   * set Object Template in map
   * @param {Object} templateWidgets
   */
  setObjectDetails(state, objectDetails) {
    if (objectDetails?.UUID) {
      state.objectDetailsMap = { ...state.objectDetailsMap, [objectDetails.UUID]: objectDetails };
    }
  },

  /**
   * Set list of DB table columns in map, used in tabular user field widget
   */
  setDbTableColumns(state, { tableName, columns }) {
    state.dbTableColumnsMap = { ...state.dbTableColumnsMap, [tableName]: columns };
  },

  setMultipleObjectDetails(state, objectDetails) {
    state.objectDetailsMap = { ...state.objectDetailsMap, ...objectDetails };
  },

  setFieldDetailsForMultipleObjects(state, fieldDetails) {
    state.objectFieldsMap = { ...state.objectFieldsMap, ...fieldDetails };
  },
  setIsDataLoaderLoading(state, loadingValue) {
    state.isDataLoaderLoading = loadingValue;
  },

  setDynamicValuesMapper(state, { uniqueId, dynamicValues }) {
    state.dynamicValuesMapper = { ...state.dynamicValuesMapper, [uniqueId]: dynamicValues };
  },
  resetDynamicValuesMapper(state, uniqueId) {
    delete state.dynamicValuesMapper[uniqueId];
  },

  setModifiedRecordMapper(state, { uniqueId, modifiedRecord }) {
    state.modifiedRecordMapper = { ...state.modifiedRecordMapper, [uniqueId]: modifiedRecord };
  },
  resetModifiedRecordMapper(state, uniqueId) {
    delete state.modifiedRecordMapper[uniqueId];
  }
};
